// Redirect slashless paths before S3/CloudFront can leak the deploy commit hash.
const url = new URL(window.location.href)

if (window.location.pathname.startsWith('/casa-chernes/checkout')) {
  window.location.replace('https://chernes.casa/checkout')
} else if (window.location.pathname.startsWith('/casa-chernes/presentes') || window.location.pathname.startsWith('/casa-chernes/loja')) {
  window.location.replace('https://gift.chernes.casa/')
} else if (window.location.pathname.startsWith('/casa-chernes/menu')) {
  window.location.replace('https://wellness.chernes.casa/')
}

const { pathname, search, hash } = window.location
const segment = pathname.split('/').pop() || ''

if (pathname !== '/' && !pathname.endsWith('/') && !segment.includes('.')) {
  window.location.replace(`${pathname}/${search}${hash}`)
}
